export default __webpack_public_path__ + "static/media/bookmark.64debfdf.svg";